/**
 * Short Link Client for Workspace Share & Buy
 * Ported from designer — uses workspace CONFIG
 */

import { CONFIG } from '../../../core/config.js'
import { createLogger } from '../../../utils/logger.js'
import { fetchWithTimeout, REQUEST_TIMEOUT_MS } from '../../../api/index.js'
const log = createLogger('design.share-buy.short-links')

function getAuthHeaders() {
  const token = localStorage.getItem('mms_customer_token')
  return token ? { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } : null
}

/**
 * Create a short link for the design product
 * @param {Object} endProductData - Must have .productId
 * @param {string} username - Current user's username
 * @returns {Promise<{code: string, short_url: string} | null>}
 */
export async function createDesignShortLink(endProductData, username) {
  const headers = getAuthHeaders()
  if (!headers) return null

  try {
    const res = await fetchWithTimeout(
      `${CONFIG.CREATOR_API}/api/short-links`,
      {
        method: 'POST',
        headers,
        body: JSON.stringify({
          type: 'product',
          source_id: String(endProductData.productId),
          target_url: `https://mamamiya.store/u/${username}/products/${endProductData.productId}`,
          platform: 'workspace',
        }),
      },
      REQUEST_TIMEOUT_MS.WRITE
    )
    const data = await res.json()
    if (data.success) return data.data
    log.warn('Short link creation failed:', data.error)
    return null
  } catch (e) {
    log.error('Short link creation error:', e)
    return null
  }
}

/**
 * Update a short link's target_url after Shopify product creation
 * @param {string} code - The short link code
 * @param {string} newTargetUrl - The Shopify product page URL
 * @returns {Promise<boolean>}
 */
export async function patchShortLinkTarget(code, newTargetUrl) {
  const headers = getAuthHeaders()
  if (!headers) return false

  try {
    const res = await fetchWithTimeout(
      `${CONFIG.CREATOR_API}/api/short-links/${code}`,
      {
        method: 'PATCH',
        headers,
        body: JSON.stringify({ target_url: newTargetUrl }),
      },
      REQUEST_TIMEOUT_MS.WRITE
    )
    const data = await res.json()
    return data.success === true
  } catch (e) {
    log.error('Short link PATCH error:', e)
    return false
  }
}
